import { StringMapping, ValueMapping } from "@opendaw/lib-std";
import { Devices } from "../../DeviceAdapter";
import { ParameterAdapterSet } from "../../ParameterAdapterSet";
import { TrackType } from "../../timeline/TrackType";
export class TapeDeviceBoxAdapter {
    type = "instrument";
    accepts = "audio";
    #context;
    #box;
    #parametric;
    namedParameter; // let typescript infer the type
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#parametric = new ParameterAdapterSet(this.#context);
        this.namedParameter = this.#wrapParameters(box);
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get labelField() { return this.#box.label; }
    get iconField() { return this.#box.icon; }
    get defaultTrackType() { return TrackType.Audio; }
    get enabledField() { return this.#box.enabled; }
    get minimizedField() { return this.#box.minimized; }
    get acceptsMidiEvents() { return false; }
    deviceHost() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    terminate() { this.#parametric.terminate(); }
    #wrapParameters(box) {
        return {
            flutter: this.#parametric.createParameter(box.flutter, ValueMapping.unipolar(), StringMapping.percent(), "flutter"),
            wow: this.#parametric.createParameter(box.wow, ValueMapping.unipolar(), StringMapping.percent(), "wow"),
            noise: this.#parametric.createParameter(box.noise, ValueMapping.unipolar(), StringMapping.percent(), "noise"),
            saturation: this.#parametric.createParameter(box.saturation, ValueMapping.unipolar(), StringMapping.percent(), "saturation")
        };
    }
}
